/* tslint:disable */
/* eslint-disable */
/**
 * SLM API used by SLM frontend
 * This is the specification of the backend APIs. The main purpose of this specification is to unify the API between SLM-backend and SLM-frontend. For localizations the Accept-Language header is used.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dl.mhs.bd3.se@ingka.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type ErrorResponse,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
} from '../models/ErrorResponse';
import {
    type OverallStoreStructureDto,
    OverallStoreStructureDtoFromJSON,
    OverallStoreStructureDtoToJSON,
} from '../models/OverallStoreStructureDto';
import {
    type ProductAreaDto,
    ProductAreaDtoFromJSON,
    ProductAreaDtoToJSON,
} from '../models/ProductAreaDto';
import {
    type RangeNodeDto,
    RangeNodeDtoFromJSON,
    RangeNodeDtoToJSON,
} from '../models/RangeNodeDto';
import {
    type SalesLocationDto,
    SalesLocationDtoFromJSON,
    SalesLocationDtoToJSON,
} from '../models/SalesLocationDto';

export interface GetProductAreaRequest {
    /**
     * Business Unit Code
     */
    buCode: string;
    /**
     * Range Group ID
     */
    rgid: string;
}

export interface GetRangeStructureTreeRequest {
    /**
     * Business Unit Code
     */
    buCode: string;
}

export interface GetSalesLocationRequest {
    /**
     * Business Unit Code
     */
    buCode: string;
    /**
     * Range Group ID
     */
    rgid: string;
}

export interface GetStoreStructureTreeRequest {
    /**
     * Business Unit Code
     */
    buCode: string;
}

/**
 * 
 */
export class SLMStructuresApi extends runtime.BaseAPI {

    /**
     * Creates request options for getProductArea without sending the request
     */
    async getProductAreaRequestOpts(requestParameters: GetProductAreaRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['buCode'] == null) {
            throw new runtime.RequiredError(
                'buCode',
                'Required parameter "buCode" was null or undefined when calling getProductArea().'
            );
        }

        if (requestParameters['rgid'] == null) {
            throw new runtime.RequiredError(
                'rgid',
                'Required parameter "rgid" was null or undefined when calling getProductArea().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['rgid'] != null) {
            queryParameters['rgid'] = requestParameters['rgid'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("slmUserBearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/structures/v1/{buCode}/productArea`;
        urlPath = urlPath.replace('{buCode}', encodeURIComponent(String(requestParameters['buCode'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Gets the product areas connected to a range group or all the unassigned product areas if the query parameter rgid is an empty string
     * Get the product areas connected to a range group or all the unassigned product areas
     */
    async getProductAreaRaw(requestParameters: GetProductAreaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ProductAreaDto>>> {
        const requestOptions = await this.getProductAreaRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProductAreaDtoFromJSON));
    }

    /**
     * Gets the product areas connected to a range group or all the unassigned product areas if the query parameter rgid is an empty string
     * Get the product areas connected to a range group or all the unassigned product areas
     */
    async getProductArea(requestParameters: GetProductAreaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ProductAreaDto>> {
        const response = await this.getProductAreaRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getRangeStructureTree without sending the request
     */
    async getRangeStructureTreeRequestOpts(requestParameters: GetRangeStructureTreeRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['buCode'] == null) {
            throw new runtime.RequiredError(
                'buCode',
                'Required parameter "buCode" was null or undefined when calling getRangeStructureTree().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("slmUserBearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/structures/v1/{buCode}/rangestructuretree`;
        urlPath = urlPath.replace('{buCode}', encodeURIComponent(String(requestParameters['buCode'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get SLM range structure tree for a business unit
     * Fetches the range structure tree
     */
    async getRangeStructureTreeRaw(requestParameters: GetRangeStructureTreeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<RangeNodeDto>>> {
        const requestOptions = await this.getRangeStructureTreeRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(RangeNodeDtoFromJSON));
    }

    /**
     * Get SLM range structure tree for a business unit
     * Fetches the range structure tree
     */
    async getRangeStructureTree(requestParameters: GetRangeStructureTreeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<RangeNodeDto>> {
        const response = await this.getRangeStructureTreeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getSalesLocation without sending the request
     */
    async getSalesLocationRequestOpts(requestParameters: GetSalesLocationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['buCode'] == null) {
            throw new runtime.RequiredError(
                'buCode',
                'Required parameter "buCode" was null or undefined when calling getSalesLocation().'
            );
        }

        if (requestParameters['rgid'] == null) {
            throw new runtime.RequiredError(
                'rgid',
                'Required parameter "rgid" was null or undefined when calling getSalesLocation().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['rgid'] != null) {
            queryParameters['rgid'] = requestParameters['rgid'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("slmUserBearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/structures/v1/{buCode}/salesLocation`;
        urlPath = urlPath.replace('{buCode}', encodeURIComponent(String(requestParameters['buCode'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Gets the sales locations connected to a range group or all the available sales locations if rgid is an empty string
     * Get the sales locations connected to a range group or all the available sales locations
     */
    async getSalesLocationRaw(requestParameters: GetSalesLocationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SalesLocationDto>>> {
        const requestOptions = await this.getSalesLocationRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SalesLocationDtoFromJSON));
    }

    /**
     * Gets the sales locations connected to a range group or all the available sales locations if rgid is an empty string
     * Get the sales locations connected to a range group or all the available sales locations
     */
    async getSalesLocation(requestParameters: GetSalesLocationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SalesLocationDto>> {
        const response = await this.getSalesLocationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getStoreStructureTree without sending the request
     */
    async getStoreStructureTreeRequestOpts(requestParameters: GetStoreStructureTreeRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['buCode'] == null) {
            throw new runtime.RequiredError(
                'buCode',
                'Required parameter "buCode" was null or undefined when calling getStoreStructureTree().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("slmUserBearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/structures/v1/{buCode}/storestructuretree`;
        urlPath = urlPath.replace('{buCode}', encodeURIComponent(String(requestParameters['buCode'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get SLM store structure tree for a business unit
     * Fetches the store structure tree
     */
    async getStoreStructureTreeRaw(requestParameters: GetStoreStructureTreeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OverallStoreStructureDto>> {
        const requestOptions = await this.getStoreStructureTreeRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OverallStoreStructureDtoFromJSON(jsonValue));
    }

    /**
     * Get SLM store structure tree for a business unit
     * Fetches the store structure tree
     */
    async getStoreStructureTree(requestParameters: GetStoreStructureTreeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OverallStoreStructureDto> {
        const response = await this.getStoreStructureTreeRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
